import React from 'react';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { CustomerRecipeCard } from '../CustomerRecipeCard/CustomerRecipeCard';

interface ICustomerRecipeHistoryProps {
  recipes: CustomerRecipe[];
}

const CustomerRecipeHistory: React.FC<ICustomerRecipeHistoryProps> = ({
  recipes
}) => {

  const render = () => {
    return (
      <>
        {recipes?.map(recipe => {
          return <CustomerRecipeCard
            key={`recipe-${recipe.id}`}
            recipe={recipe}
          />;
        })}
      </>
    )
  }

  return render();
}

export { CustomerRecipeHistory };